export default function Divider({ full }) {
  return (
    <hr
      className={`${
        full ? 'col-start-1' : 'col-start-1 md:col-start-5'
      } col-end-13 border-black/[.15] border-[0.5px] dark:border-white/[.15] border-solid`}
    />
  );
}
